const ErmsUrl = "https://pxbjz.1v1jy.com";
// const ErmsUrl = "https://pxbjz.getdreamstar.com";

export default {
  ErmsUrl
};



// WEBPACK FOOTER //
// ./src/api/etmsConfig.js